import React, { FC, memo } from 'react'
import styles from './index.module.scss'
import { useTranslation } from '@/services/i18n'
import { Button } from 'antd'

interface DrawerFooterProps {
  onCancel?: () => void
  onOk?: () => void
  disabledOk?: boolean
  okText?: string | null
  cancelText?: string
  isLoading?: boolean
  children?: React.ReactNode
}

const DrawerFooter: FC<DrawerFooterProps> = ({
  okText,
  cancelText,
  onCancel,
  onOk,
  disabledOk,
  isLoading = false,
  children,
}) => {
  const { t } = useTranslation()
  return (
    <div className={styles.footer}>
      {children ? (
        children
      ) : (
        <>
          <Button onClick={() => onCancel?.()}>{cancelText || t('common.cancel')}</Button>
          <Button type="primary" disabled={disabledOk} onClick={onOk} loading={isLoading}>
            {okText || t('common.save')}
          </Button>
        </>
      )}
    </div>
  )
}

export default memo(DrawerFooter)
